module.exports = __webpack_public_path__ + "static/media/click.97793a15.wav";


//////////////////
// WEBPACK FOOTER
// ./src/sound/click.wav
// module id = 35
// module chunks = 0